import { useQuery } from '@tanstack/react-query';

import { AuthorityService } from '../services';
import { useHasPermission } from '../hooks';

export const useAuthorityHistory = (authorityUuid: string) => {
  const queryKey = ['authorityHistory', authorityUuid];
  const canViewHistory = useHasPermission('authorities:read:history');

  const queryFn = () => AuthorityService.getHistory(authorityUuid);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!authorityUuid && canViewHistory,
    staleTime: 0,
  });
};
